module.exports = __webpack_public_path__ + "e-learning-app/static/img/cs1.888081c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cs1.png
// module id = IJQZ
// module chunks = 1